<template>
  <div class="goods-ceil-container">
    <div
      class="ceil-container"
      v-for="(item, index) in goodsList"
      :key="item.id"
    >
      <div class="img-box c-pointer" @click="toDetailPage(item)">
        <img v-lazy="item.image ? item.image : $defaultImg" alt="" />
      </div>

      <div class="price" v-if="$store.state.hasLogin && !item.isForbidAreaSale">
        <span class="span1"
          ><i>￥</i>{{ item.goodsActivityInfoMap.priceStr }}</span
        >
        <span class="span2" v-if="item.goodsActivityInfoMap.resetPrice"
          ><i>￥</i>{{ item.goodsActivityInfoMap.goodsPriceStr }}</span
        >
      </div>
      <div class="price" v-if="!$store.state.hasLogin">
      </div>
      <div class="price" v-if="$store.state.hasLogin && item.isForbidAreaSale">
        <span class="span3">地区禁售，价格不可见</span>
      </div>

      <div class="name">
        <p>
          <i v-if="item.goodsActivityInfoMap.activity">{{
            item.goodsActivityInfoMap.activityBadge
          }}</i>
          <span
            @click="toDetailPage(item)"
            class="c-pointer"
            :title="item.name"
            >{{ item.name }}</span
          >
        </p>
      </div>
      <div class="stock">
        <span>剂型：</span>
        <span>{{ item.jixing }}</span>
      </div>
      <div class="stock">
        <span>剂量规格：</span>
        <span>{{ item.jlgg }}</span>
      </div>
      <!-- <div class="add">
        <input-number
          ref="inputNumber"
          :maxNumber="
            item.stock > item.goodsActivityInfoMap.limitedCount
              ? item.goodsActivityInfoMap.limitedCount
              : item.stock
          "
          :skuNum="item.zhxs ? item.zybz : ''"
          v-if="item.goodsActivityInfoMap.limited"
        ></input-number>
        <input-number
          :maxNumber="item.stock"
          ref="inputNumber"
          :skuNum="item.zhxs ? item.zybz : ''"
          v-else
        ></input-number>
        <span
          class="add-cart no-select"
          v-if="item.stock > 0 && !item.isForbidAreaSale"
          @click="add(item, index)"
          >加入购物车</span
        >
        <span
          class="remind no-select"
          v-if="item.stock == 0 && !item.isForbidAreaSale"
          @click="prePay(item.id)"
          >到货提醒</span
        >
        <span class="forbid no-select" v-if="item.isForbidAreaSale"
          >地区禁购</span
        >
      </div> -->
    </div>
    <popup
      class="popup-info"
      width="350px"
      height="200px"
      @close="close"
      v-if="show"
    >
      <div v-if="type == 1">
        <img
          class="close"
          :src="require('@/assets/images/icon_xx3.png')"
          alt=""
          @click="close"
        />
        <div class="title">该商品暂无库存，确定预购吗</div>
        <div class="btn">
          <span class="span1" @click="confirm">确定</span>
          <span class="span2" @click="close">取消</span>
        </div>
      </div>

      <div v-if="type == 2">
        <div class="header">
          <span>出错提示</span>
          <img
            class="close2"
            :src="require('@/assets/images/x.png')"
            alt=""
            @click="close"
          />
        </div>
        <div class="middle">
          <img
            class="errimg"
            :src="require('@/assets/images/t_s.png')"
            alt=""
          />
          <span>{{ message }}</span>
        </div>
      </div>
    </popup>
    <success v-if="successShow">{{ message }}</success>
  </div>
</template>

<script>
import inputNumber from "./input-number.vue";
import success from "@/components/success.vue";

export default {
  components: { inputNumber, success },
  data() {
    return {
      show: false,
      successShow: false,
      message: "",
      type: 1
    };
  },
  created() {},
  props: ["goodsList"],
  methods: {
    isZGS(name) {
      return name.indexOf("珍贵膳") != -1;
    },
    toDetailPage(item) {
      // this.$router.push({
      //   name:'detail',
      //     query: {
      //     goodsId: item.id,
      //     type:1,
      //     keyword:this.$route.query.keyword
      //   }
      // })
      let routeData = this.$router.resolve({
        path: `/detail?goodsId=${item.id}&type=1&keyword=${this.$route.query.keyword}`
      });
      window.open(routeData.href, "_blank");
    },
    add(item, index) {
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      let num = this.$refs.inputNumber[index].number;
      let id = item.id;
      this.$api
        .POST_ADDCART({
          cartItemType: "goods", //combination
          id,
          quantity: num
        })
        .then(res => {
          if (res.status) {
            this.message = "加购成功";
            this.successShow = true;
            this.$store.commit(
              "GETCARTCOUNT",
              Number(this.$store.state.cartNum) + Number(num)
            );
            this.ANALYSISSAVE(item, 1);
          } else {
            this.show = true;
            this.message = res.message;
            this.type = 2;
          }
        });
    },
    success() {
      this.successShow = false;
    },
    prePay(id) {
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      this.type = 1;
      this.show = true;
      this.itemId = id;
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.$api
        .POST_SUBSCRIBESAVE({
          goodsId: this.itemId,
          quantity: 1
        })
        .then(res => {
          if (res.status) {
            this.message = "预购成功";
            this.successShow = true;
          }
          this.show = false;
        });
    },
    ANALYSISSAVE(gooodsDetail, savetype) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let goodsId = gooodsDetail.id;
      let content = gooodsDetail.name;
      let goodsName = gooodsDetail.name;
      let keyword = this.$route.query.keyword;
      let url;
      let title;
      let type;
      if (savetype == 1) {
        (title = "加入购物车"), (type = "cart");
      } else {
        (title = "访问商品"), (type = "detail");
      }

      url = `http://www.dgsjyyy.com/detail?goodsId=${gooodsDetail.id}&type=1`;
      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          content,
          goodsId,
          goodsName,
          keyword
        })
        .then(res => {})
        .catch(err => console.log(err));
    }
  }
};
</script>
<style lang="scss" scoped>
.goods-ceil-container {
  overflow: hidden;
}
.ceil-container {
  float: left;
  margin: 5px 5px 10px;
  padding: 10px 15px;
  width: 230px;
  height: 390px;
  border-radius: 3px;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 0 10px 5px #f0f0f0;
  }
  .img-box {
    text-align: center;
    margin-bottom: 14px;
    position: relative;
    img {
      width: 200px;
      height: 200px;
    }
    .forbidInfo {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 25px;
      background: #f8b737;
      color: #ffffff;
      line-height: 25px;
      text-align: center;
    }
  }
  .price {
    margin-bottom: 10px;
    .span1 {
      font-size: 20px;
      color: #fa4b4b;
      font-weight: 600;
      i {
        font-size: 13px;
      }
    }
    .span2 {
      font-size: 13px;
      color: #999999;
      text-decoration: line-through;
    }
    .span3 {
      font-size: 17px;
      color: #fa4b4b;
      font-weight: 600;
    }
  }
  .name {
    //  margin-bottom: 4px;
    p {
      font-size: 14px;
      color: #505050;
      line-height: 24px;
      height: 30px;
      @include textLineClamp(1);
      i {
        min-width: 40px;
        height: 20px;
        display: inline-block;
        border: 1px solid #fa4b4b;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #fa4b4b;
        border-radius: 2px;
        padding: 0 4px;
      }
    }

    .span2 {
      margin-top: 30px;
      word-wrap: break-word;
    }
  }
  .stock {
    font-size: 13px;
    color: #808080;
    margin-bottom: 7px;
  }
  .add {
    display: flex;
    span {
      width: 80px;
      height: 32px;
      display: inline-block;
      background: #fa4b4b;
      border-radius: 3px;
      color: #ffffff;
      font-size: 14px;
      margin-left: 10px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
    }
    .remind {
      background: rgb(255, 204, 81);
    }
    .forbid {
      background: #d8d8d8;
      color: #a0a0a0;
    }
  }
}

.popup-info {
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 38px;
  }
  .btn {
    text-align: center;
    span {
      @include btn(124px, 44px, #fa4b4b, #ffffff, 16px, 2px);
    }
    .span2 {
      border: 1px solid #fa4b4b;
      color: #fa4b4b;
      background: none;
      margin-left: 20px;
    }
  }
  .close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
.header {
  height: 44px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
  span {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
    margin-left: 17px;
  }
  .close2 {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
}
.middle {
  align-items: center;
  @include flex-d-c;
  img {
    width: 104px;
    height: 83px;
    margin: 12px 0;
  }
  span {
    font-size: 16px;
    color: #333333;
    padding: 20px 30px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goods-list-ceil.vue